import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import ManageUserComponent from '../../components/ManageUserComponent/ManageUserComponent'

const ManageUser = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ManageUserComponent/>
                </div>
            </div>
        </div>
    )
}

export default ManageUser
